import { render, staticRenderFns } from "./UserImageEdit.vue?vue&type=template&id=1455a48b"
import script from "./UserImageEdit.vue?vue&type=script&lang=js"
export * from "./UserImageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports